import { Component } from 'react';
import AuthService from '../services/api/auth';
import Bugsnag from '@bugsnag/js';
export default class AbstractDocumentCheck extends Component {
    cancel() {
        this.setState({ frontPicture: null, backPicture: null });
        this.imageFrontPicker.reset();
        if (this.imageBackPicker) {
            this.imageBackPicker.reset();
        }

        AuthService.getAccountStatus().then(response => {
            response.steps.forEach((entry, i) => {
                if (entry.path === this.props.location.pathname) {
                    if (entry.back) {
                        this.props.history.push(entry.back);
                    } else {
                        const lastScreen = response.steps[i - 1];
                        if (lastScreen && lastScreen.path) {
                            this.props.history.push(lastScreen.path);
                        }
                    }
                }
            });
        });
    }

    componentDidMount() {
        //this is a new session, remove cookie;
        this.props.setStep(this.state.type.toUpperCase());
    }

    createDocumentInstance() {
        return AuthService.createDocumentInstance(this.state.type).then(() => true);
    }

    onFrontDrop(frontPicture) {
        this.setState({
            frontPicture,
            btnLabel: 'Next',
            classification: null,
        });
    }

    onBackDrop(backPicture) {
        this.setState({
            backPicture,
            btnLabel: 'Next',
            classification: null,
        });
    }

    async doClassification() {
        return AuthService.documentClassification(this.state.type)
            .then(response => {
                let errors = [...this.state.errors];

                if (!response.isDocumentTypeMatching) {
                    errors.push(`${this.state.type.toUpperCase()}_DOCUMENT_TYPE_MISMATCH`);
                }
                this.setState({
                    classification: true,
                    errors,
                    isDocumentTypeMatching: response.isDocumentTypeMatching,
                });
                return response.isDocumentTypeMatching;
            })
            .catch(e => {
                /**
                 * it means we couldn't perform image classification assessment.
                 * better to ignore this validation
                 */
                return true;
            });
    }

    /**
     * wip
     * @returns {Promise<void>}
     */
    async savePhoto() {
        this.setState({
            loading: true,
            errors: [],
            canContinue: true,
        });

        const documentInstanceResult = await this.createDocumentInstance().catch(e => {
            if (e && e.data && e.data.message) {
                Bugsnag.notify(e.data);
                this.setState({
                    loading: false,
                    errors: [e.data.message],
                    canContinue: false,
                });
            } else if (e && e.message) {
                Bugsnag.notify(e);
                this.setState({
                    loading: false,
                    errors: [e.message],
                });
            } else {
                this.setState({
                    loading: false,
                    errors: ['DEFAULT_ERROR_MESSAGE'],
                    canContinue: false,
                });
            }
            return false;
        });

        if (!documentInstanceResult) {
            return this.setState({
                loading: false,
            });
        }

        const uploadResult = await this.uploadImages();

        if (!uploadResult) {
            return this.setState({
                loading: false,
            });
        }

        /**
         * force the user to classify his documents first before validating the documents
         */
        if (!this.state.classification) {
            let batchTesting = await Promise.all([this.doClassification(), this.validateDocumentImageQuality()]);
            // let classificationTestResult = await this.doClassification();
            //
            //
            /**
             * don't continue if classification / image metrics was not ok
             */
            if (!batchTesting[0] || !batchTesting[1]) {
                return this.setState({
                    btnLabel: 'Continue',
                    loading: false,
                });
            }
        }

        /**
         * user confirmed his documents, it's up for the api to validate them
         */
        this.validateDocument()
            .then(() => {
                AuthService.getAccountStatus()
                    .then(response => {
                        if (response.next === null) {
                            this.props.history.push('/register/status');
                        } else {
                            this.props.history.push(response.next);
                        }
                    })
                    .catch(e => {
                        this.setState({ canContinue: false });
                        if (e && e.data && e.data.message) {
                            this.setState({ errors: [e.data.message] });
                        }
                    });
            })
            .catch(e => {
                this.setState({ canContinue: false });
            });
    }

    async uploadImages() {
        const frontPicture = new FormData();
        frontPicture.append('image', this.state.frontPicture);
        window[`VULOG_${this.state.type.toUpperCase()}_FRONT_IMAGE`] = this.state.frontPicture;

        let backPicture = null;
        if (this.state.backPicture) {
            backPicture = new FormData();
            backPicture.append('image', this.state.backPicture);
            window[`VULOG_${this.state.type.toUpperCase()}_BACK_IMAGE`] = this.state.backPicture;
        }

        return Promise.all(
            this.state.backPicture
                ? [
                      AuthService.uploadDocumentImage(this.state.type, 0, frontPicture),
                      AuthService.uploadDocumentImage(this.state.type, 1, backPicture),
                  ]
                : [AuthService.uploadDocumentImage(this.state.type, 0, frontPicture)]
        )
            .then(() => {
                return true;
            })
            .catch(e => {
                Bugsnag.notify(e);
                if (e && e.data && e.data.message) {
                    this.setState({
                        errors: [e.data.message],
                    });
                }
                return false;
            });
    }

    async validateDocumentImageQuality() {
        return AuthService.documentImageQuality(this.state.type)
            .then(response => {
                let imageQualityCheckPass = true;
                let qualityErrors = new Set(this.state.errors);

                response.forEach(side => {
                    if (imageQualityCheckPass) {
                        imageQualityCheckPass = side.errors.length === 0;
                    }
                    side.errors.forEach(e => qualityErrors.add(e));
                });

                this.setState({
                    errors: [...qualityErrors],
                });
                return imageQualityCheckPass;
            })
            .catch(e => {
                /**
                 * it means we couldn't perform image quality assessment.
                 * better to ignore this validation
                 */
                return true;
            });
    }

    /**
     * method used to validate current uploaded documents
     * @returns {Promise<boolean>}
     */
    async validateDocument() {
        return AuthService.validateDocument(this.state.type).catch(e => {
            this.setState({
                loading: false,
            });
            if (e && e.data && e.data.message) {
                this.setState({
                    errors: [e.data.message],
                    canContinue: false,
                });
                throw new Error();
            }
        });
    }
}
